import { render } from "./batchOrderModal.vue?vue&type=template&id=598b2e90&scoped=true"
import script from "./batchOrderModal.vue?vue&type=script&lang=js"
export * from "./batchOrderModal.vue?vue&type=script&lang=js"

import "./batchOrderModal.vue?vue&type=style&index=0&id=598b2e90&lang=scss&scoped=true"

import exportComponent from "D:\\web-master\\TikTokWeb\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-598b2e90"]])

export default __exports__